<template>
  <div>
    <LoaderApp v-if="loading"></LoaderApp>
    <div v-else>
      <TituloComponent icono-titulo="fas fa-boxes" :texto-titulo="articulo.descripcion"></TituloComponent>
      <div class="card p-2 my-2">
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-info btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >Volver
            </button>
          </div>
          <div class="col-md-2 offset-md-6">
            <router-link
              class="btn btn-block btn-warning text-white mb-2 mb-md-0"
              :to="{name:'EditarArticulo', params:{id:articulo.id}}"
            >Editar
            </router-link>
          </div>
          <div class="col-md-2">
            <button
              v-if="articulo.activo || articulo.activo === undefined"
              class="btn btn-danger btn-block mb-2 mb-md-0"
              type="button"
              @click="desactivarArticulo()"
            >Desactivar
            </button>
            <button
              v-else
              class="btn btn-success btn-block mb-2 mb-md-0"
              type="button"
              @click="reactivarArticulo()"
            >Reactivar
            </button>
          </div>
        </div>
      </div>
      <div class="card p-2 my-2">
        <div class="no-gutters row">
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Precio venta:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-success m-0 widget-heading">${{ articulo.precio_venta }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Precio compra:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading text-alternate">${{ articulo.precio_compra }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Stock actual:</p>
                </div>
                <div class="widget-content-left">
                  <p :class="((articulo.stock <= articulo.stock_minimo) ? 'text-danger' : '') + ' m-0 widget-heading '">
                    {{ articulo.stock }} <span class="text-danger" v-if="articulo.stock_reservado">(+{{articulo.stock_reservado}} reservados para pedidos pendientes)</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Stock mínimo:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{ articulo.stock_minimo }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">IVA:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{ articulo.iva.descripcion }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Marca:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{ articulo.marca ? articulo.marca.descripcion : '' }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Familia:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{ articulo.familia.descripcion }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card my-2">
        <div class="card-body">
          <h4 class="mb-4">Movimientos</h4>
          <div class="row">
            <div class="widget-wrapper col-lg-4">
              <div class="widget-heading opacity-10">
                <float-label label="Desde:" clase=" mb-md-0">
                  <input type="date" id="desde" class="form-control" v-model="desde">
                </float-label>
              </div>
            </div>
            <div class="widget-wrapper col-lg-4">
              <div class="widget-heading opacity-10">
                <float-label label="Hasta:" clase="mb-md-0">
                  <input type="date" id="hasta" class="form-control" v-model="hasta">
                </float-label>
              </div>
            </div>
            <div class="widget-wrapper col-lg-4">
              <div class="widget-heading opacity-10">
                <button type="button" @click="getActividadArticulo" class="btn btn-block btn-info">Buscar</button>
              </div>
            </div>
          </div>
          <div class="row">
            <ul class="list-group list-group-flush my-3 w-100">
              <li
                class="list-group-item hoverable"
                v-for="actividad in actividad_articulo"
                :key="actividad.id"
              >
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper row">
                    <div class="widget-content-left col-12">
                      <h5 class="widget-heading">{{ actividad.info }}
                        <template v-if="actividad.movimiento_id !== null">
                          <span class="text-info">#{{actividad.movimiento.denominacion}}</span>
                        </template>
                      </h5>
                      <div class="widget-subheading opacity-10 row">
                        <template v-if="actividad.stock_anterior !== actividad.stock_nuevo">
                          <span class="col-sm-auto col-6">
                            Cambio de stock:
                            <b class="text-danger">{{ actividad.stock_anterior }}</b>
                            <i class="fa fa-arrow-right text-muted fsize-1 mx-2"></i>
                            <b class="text-success">{{ actividad.stock_nuevo }}</b>
                          </span>
                        </template>
                      </div>
                      <div class="widget-subheading opacity-10 row">
                        <template v-if="actividad.precio_anterior !== actividad.precio_nuevo">
                          <span class="col-sm-auto col-6">
                            Precio anterior:
                            <b class="text-danger">${{ actividad.precio_anterior }}</b>
                          </span>
                          <span class="col-sm-auto col-6">
                            Precio nuevo:
                            <b class="text-success">${{ actividad.precio_nuevo }}</b>
                          </span>
                        </template>
                      </div>
                      <div class="widget-subheading opacity-10 row">
                          <span class="col-sm-auto col-6">
                            Realizado por:
                            <b class="text-primary">{{ actividad.user.nombre }}</b>
                          </span>
                        <span class="col-sm-auto col-6">
                            Fecha por:
                            <b class="text-primary">{{ actividad.created_at | moment("DD/MM/YYYY hh:mm") }}</b>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Articulo from "@/models/articulo";
import Swal from "sweetalert2";
import axios from "axios";
import LoaderApp from "@/components/loaders/LoaderApp";
import FloatLabel from "@/components/layouts/FloatLabel.vue";
import TituloComponent from "@/components/layouts/TituloComponent.vue";

export default {
  name: "VerCliente",
  components: {
    TituloComponent,
    FloatLabel,
    LoaderApp
  },
  data() {
    return {
      articulo: new Articulo(
        null,
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        5
      ),
      loading: true,
      desde: null,
      hasta: null,
      actividad_articulo: []
    };
  },
  mounted() {
    let date = new Date();
    let first_day = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let last_day = new Date(date.getFullYear(), date.getMonth(), 0);
    this.desde = this.$options.filters.moment(first_day, 'YYYY-MM-DD');
    this.hasta = this.$options.filters.moment(last_day, 'YYYY-MM-DD');
    this.articulo.id = this.$route.params.id;
    this.getArticulo();
  },
  methods: {
    getArticulo() {
      this.loading = true;
      axios
        .get("/articulos/" + this.articulo.id)
        .then(res => {
          if (res.data.success) {
            this.articulo = res.data.articulo;
          }
        })
        .catch(() => {
          Swal.fire(
              "Error",
              `Error al cargar artículo.`,
              "error"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    desactivarArticulo() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas desactivar ${this.articulo.descripcion}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Desactivar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/articulos/" + this.articulo.id)
            .then(res => {
              if (res.data.success) {
                Swal.fire("Desactivado", `${this.articulo.descripcion} se ha desactivado.`, "success");
                this.articulo.activo = false;
              }
            })
            .catch(err => {
              if (err.response && err.response.data && err.response.data.error) {
                Swal.fire("Error", err.response.data.error, "warning");
              }
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    reactivarArticulo() {
      this.loading = true;
      axios
        .put("/articulos/" + this.articulo.id + "/reactivar")
        .then(res => {
          if (res.data.success) {
            Swal.fire("Reactivado", `${this.articulo.descripcion} se ha reactivado.`, "success");
            this.articulo.activo = true;
          }
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    getActividadArticulo() {
      this.loading = true;
      axios
        .get("/actividad-articulo/", {params: {id: this.articulo.id, desde: this.desde, hasta: this.hasta}})
        .then(res => {
          this.actividad_articulo = res.data;
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
